// ---------------------------------------------------------------------------
// MIME type → Attachment type mapping
// ---------------------------------------------------------------------------
function deriveAttachmentType(mimeType) {
    if (mimeType.startsWith('image/'))
        return 'image';
    if (mimeType.startsWith('audio/'))
        return 'audio';
    return 'document';
}
export function mapUserFileRefToAttachment(ref) {
    return {
        id: ref.file_id,
        name: ref.file_name,
        type: deriveAttachmentType(ref.mime_type),
        status: ref.scan_status,
        errorMessage: ref.error_message
    };
}
export function mapUserFileRefsToAttachments(refs) {
    return refs.map(mapUserFileRefToAttachment);
}
